<template>
  <div class="container text-secondary">
    <!-- Header -->
    <div class="row mb-3">
      <div class="col-2"/>
      <div class="col text-center">
        <div class="h4">🎯 Darten</div>
      </div>
      <div class="col-2 text-end pe-2">
        <img src="@/assets/back-48.png" alt="terug" class="img-fluid"
             style="height:32px; cursor:pointer;" @click="$router.push('/')"/>
      </div>
    </div>

    <hr class="divider">

    <!-- Setup scherm -->
    <div v-if="fase === 'setup'">
      <div class="card-modern">
        <div class="row mb-3">
          <div class="col-5 text-end fw-bold pt-1">Spel:</div>
          <div class="col text-start">
            <button v-for="s in [301, 501]" :key="s"
                    class="btn btn-sm me-2"
                    :class="startScore === s ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="startScore = s">
              {{ s }}
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-5 text-end fw-bold pt-1">Format:</div>
          <div class="col text-start">
            <button v-for="f in ['single', 'dubbel']" :key="f"
                    class="btn btn-sm me-2"
                    :class="format === f ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="format = f">
              {{ f === 'single' ? 'Single' : 'Dubbel' }}
            </button>
          </div>
        </div>

        <div v-if="format === 'dubbel'" class="row mb-3">
          <div class="col-5 text-end fw-bold pt-1">Teams:</div>
          <div class="col text-start" style="font-size:0.9rem; color:#4a5568;">
            <div>Team 1: {{ players[0]?.name }} &amp; {{ players[1]?.name }}</div>
            <div>Team 2: {{ players[2]?.name }} &amp; {{ players[3]?.name }}</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-5 text-end fw-bold pt-1">Best of games:</div>
          <div class="col text-start">
            <button v-for="n in [1, 3, 5]" :key="n"
                    class="btn btn-sm me-2"
                    :class="bestOfGames === n ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="bestOfGames = n">
              {{ n }}
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-5 text-end fw-bold pt-1">Best of legs:</div>
          <div class="col text-start">
            <button v-for="n in [1, 3, 5]" :key="n"
                    class="btn btn-sm me-2"
                    :class="bestOfLegs === n ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="bestOfLegs = n">
              {{ n }}
            </button>
          </div>
        </div>

        <hr class="divider">

        <div class="row">
          <div class="col text-muted" style="font-size:0.85rem; line-height:1.6;">
            Score per beurt invoeren (totaal 3 pijlen).<br>
            Bust = terug naar vorige score.<br>
            Precies op 0 = leg gewonnen. 🎯
          </div>
        </div>
      </div>

      <div class="text-center">
        <button class="btn-primary-modern" :disabled="!setupGeldig" @click="naarBulloff">
          Verder
        </button>
      </div>
    </div>

    <!-- Bulloff: wie begint? -->
    <div v-else-if="fase === 'bulloff'">
      <div class="card-modern text-center">
        <div style="font-size:1.3rem; font-weight:800; color:#2d3748; margin-bottom:8px;">
          🎯 Wie begint?
        </div>
        <div style="color:#718096; font-size:0.9rem; margin-bottom:20px;">
          Wie gooide het dichtste bij de bull?
        </div>
        <div class="row g-2">
          <div v-for="(naam, i) in beginnerOpties" :key="i" class="col-6">
            <div class="pit-optie text-center" @click="startSpel(i)">
              <div style="font-size:1.5rem;">{{ i % 2 === 0 ? '👨' : '👩' }}</div>
              <div style="font-weight:700; color:#2d3748; margin-top:4px;">{{ naam }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Spel bezig -->
    <div v-else-if="fase === 'spelen'">

      <!-- Game / Leg status -->
      <div class="card-modern mb-2">
        <div class="row text-center">
          <div class="col">
            <div style="font-size:0.8rem; color:#a0aec0;">Game</div>
            <div style="font-weight:800; color:#2d3748;">{{ huidigGame }} / {{ benodigdeGames }}</div>
          </div>
          <div class="col">
            <div style="font-size:0.8rem; color:#a0aec0;">Leg</div>
            <div style="font-weight:800; color:#2d3748;">{{ huidigLeg }} / {{ benodigdeLegs }}</div>
          </div>
          <div class="col" v-for="(naam, i) in teamNamen" :key="i">
            <div style="font-size:0.8rem; color:#a0aec0;">{{ naam }}</div>
            <div style="font-weight:800; color:#667eea;">
              {{ legWinsten[huidigGame - 1]?.[i] || 0 }}
              <span style="color:#a0aec0; font-size:0.75rem;">legs</span>
            </div>
          </div>
          <div class="col" v-for="(naam, i) in teamNamen" :key="'g'+i">
            <div style="font-size:0.8rem; color:#a0aec0;">Games {{ naam }}</div>
            <div style="font-weight:800; color:#e53e3e;">{{ gameWinsten[i] || 0 }}</div>
          </div>
        </div>
      </div>

      <!-- Score invoer -->
      <div class="card-modern mb-2">
        <div class="text-center mb-2">
          <div style="font-weight:700; color:#4a5568; font-size:1rem;">
            🎯 {{ huidigTeamNaam }} is aan de beurt
          </div>
          <div style="font-size:0.85rem; color:#a0aec0;">
            Resterend: <strong style="font-size:1.2rem; color:#667eea;">{{ huidigScore }}</strong>
          </div>
        </div>

        <!-- Display invoer -->
        <div style="background:#f7fafc; border-radius:12px; padding:12px; text-align:center; margin-bottom:12px; font-size:2rem; font-weight:800; color:#2d3748; min-height:56px; letter-spacing:4px;">
          {{ invoer || '0' }}
        </div>

        <!-- Cijfertoetsen -->
        <div class="cijfer-grid mb-2">
          <button v-for="n in [1,2,3,4,5,6,7,8,9]" :key="n"
                  class="cijfer-btn" @click="invoerCijfer(n)">{{ n }}</button>
          <button class="cijfer-btn" @click="invoerCijfer(0)">0</button>
          <button class="cijfer-btn delete-btn" @click="verwijderCijfer">⌫</button>
        </div>

        <button class="btn-primary-modern" style="width:100%;" @click="bevestigScore">
          Bevestig
        </button>
      </div>

      <!-- Scorekaart (dartkaart stijl) -->
      <div class="card-modern">
        <div class="h6 mb-2">Scorekaart</div>
        <table class="dart-table">
          <thead>
          <tr>
            <th class="dart-score-col">{{ teamNamen[0] }}</th>
            <th class="dart-rest-col"></th>
            <th class="dart-rest-col"></th>
            <th class="dart-score-col">{{ teamNamen[1] }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="dart-score-col"/>
            <td class="dart-rest-col start-score">{{ startScore }}</td>
            <td class="dart-rest-col start-score">{{ startScore }}</td>
            <td class="dart-score-col"/>
          </tr>
          <tr v-for="(rij, i) in scoreRijen" :key="i">
            <td class="dart-score-col">{{ rij.worp0 ?? '' }}</td>
            <td class="dart-rest-col">{{ rij.rest0 ?? '' }}</td>
            <td class="dart-rest-col">{{ rij.rest1 ?? '' }}</td>
            <td class="dart-score-col">{{ rij.worp1 ?? '' }}</td>
          </tr>
          <!-- lege rij voor huidige beurt -->
          <tr class="actieve-rij">
            <td class="dart-score-col">{{ huidigTeam === 0 ? (invoer || '') : '' }}</td>
            <td class="dart-rest-col">{{ huidigTeam === 0 ? (invoer ? huidigScore - parseInt(invoer) : '') : '' }}</td>
            <td class="dart-rest-col">{{ huidigTeam === 1 ? (invoer ? huidigScore - parseInt(invoer) : '') : '' }}</td>
            <td class="dart-score-col">{{ huidigTeam === 1 ? (invoer || '') : '' }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Leg kruisjes -->
      <div class="card-modern">
        <div class="h6 mb-2">Legs</div>
        <div class="row text-center">
          <div class="col" v-for="(naam, i) in teamNamen" :key="i">
            <div style="font-size:0.85rem; font-weight:700; color:#4a5568; margin-bottom:6px;">{{ naam }}</div>
            <div>
              <span v-for="j in (legWinsten[huidigGame - 1]?.[i] || 0)" :key="j"
                    style="font-size:1.4rem; margin:2px;">✕</span>
              <span v-if="!(legWinsten[huidigGame - 1]?.[i])" style="color:#e2e8f0;">–</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Winnaar -->
    <div v-else-if="fase === 'klaar'">
      <div class="card-modern text-center">
        <div style="font-size:3rem;">🏆</div>
        <div class="h4 mt-2">{{ winnaarNaam }} wint!</div>
        <div style="color:#718096; margin-top:8px;">
          Games: {{ gameWinsten[0] }} – {{ gameWinsten[1] }}
        </div>
        <button class="btn-primary-modern mt-4" @click="fase = 'setup'">
          Nieuw spel
        </button>
      </div>

      <!-- Eindstand games -->
      <div class="card-modern">
        <div class="h6 mb-2">Eindstand</div>
        <div class="row text-center">
          <div class="col" v-for="(naam, i) in teamNamen" :key="i">
            <div style="font-weight:700; color:#4a5568;">{{ naam }}</div>
            <div style="font-size:2rem; font-weight:800; color:#667eea;">{{ gameWinsten[i] }}</div>
            <div style="font-size:0.8rem; color:#a0aec0;">games</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "DartenGame",
  data() {
    return {
      fase: 'setup',
      startScore: 501,
      format: 'single',
      bestOfGames: 1,
      bestOfLegs: 1,

      huidigGame: 1,
      huidigLeg: 1,
      huidigTeam: 0,        // 0 of 1
      scores: [0, 0],       // huidige restscores per team
      invoer: '',
      beurten: [],          // { team, worp, rest } per beurt in deze leg
      legWinsten: [],       // legWinsten[gameIndex][teamIndex]
      gameWinsten: [0, 0],
      winnaarNaam: '',
    };
  },
  computed: {
    players() {
      return store.state.players;
    },
    setupGeldig() {
      if (this.format === 'single') return this.players.length >= 2;
      return this.players.length >= 4;
    },
    benodigdeGames() {
      return Math.ceil(this.bestOfGames / 2) * 2 - 1; // 1→1, 3→2, 5→3 nodig om te winnen
    },
    benodigdeLegs() {
      return Math.ceil(this.bestOfLegs / 2) * 2 - 1;
    },
    teamNamen() {
      if (this.format === 'single') {
        return [
          this.players[0]?.name || 'Team 1',
          this.players[1]?.name || 'Team 2',
        ];
      }
      return [
        `${this.players[0]?.name} & ${this.players[1]?.name}`,
        `${this.players[2]?.name} & ${this.players[3]?.name}`,
      ];
    },
    beginnerOpties() {
      if (this.format === 'single') {
        return [this.players[0]?.name, this.players[1]?.name];
      }
      return [
        this.players[0]?.name,
        this.players[1]?.name,
        this.players[2]?.name,
        this.players[3]?.name,
      ];
    },
    huidigTeamNaam() {
      return this.teamNamen[this.huidigTeam];
    },
    huidigScore() {
      return this.scores[this.huidigTeam];
    },
    scoreRijen() {
      // Bouw rijen op voor de scorekaart
      const rijen = [];
      let i = 0;
      while (i < this.beurten.length) {
        const b0 = this.beurten[i];
        const b1 = this.beurten[i + 1];
        if (b0?.team === 0) {
          rijen.push({
            worp0: b0.worp,
            rest0: b0.rest,
            worp1: b1?.worp,
            rest1: b1?.rest,
          });
          i += 2;
        } else {
          rijen.push({
            worp0: undefined,
            rest0: undefined,
            worp1: b0.worp,
            rest1: b0.rest,
          });
          i += 1;
        }
      }
      return rijen;
    },
  },
  methods: {
    naarBulloff() {
      this.fase = 'bulloff';
    },
    startSpel(spelerIndex) {
      // Bepaal welk team begint op basis van gekozen speler
      this.huidigTeam = this.format === 'single'
          ? spelerIndex
          : spelerIndex < 2 ? 0 : 1;
      this.resetLeg();
      this.legWinsten = Array.from({ length: this.bestOfGames }, () => [0, 0]);
      this.gameWinsten = [0, 0];
      this.huidigGame = 1;
      this.huidigLeg = 1;
      this.fase = 'spelen';
    },
    resetLeg() {
      this.scores = [this.startScore, this.startScore];
      this.beurten = [];
      this.invoer = '';
    },
    invoerCijfer(n) {
      if (this.invoer.length >= 3) return;
      if (this.invoer === '' && n === 0) return;
      const nieuw = this.invoer + n;
      if (parseInt(nieuw) > 180) return; // max score per beurt
      this.invoer = nieuw;
    },
    verwijderCijfer() {
      this.invoer = this.invoer.slice(0, -1);
    },
    bevestigScore() {
      const worp = parseInt(this.invoer) || 0;
      const huidig = this.scores[this.huidigTeam];
      const nieuw = huidig - worp;

      // Bust check: onder 0 of op 1
      if (nieuw < 0 || nieuw === 1) {
        // Bust: score blijft staan, beurt gaat naar andere team
        this.beurten.push({ team: this.huidigTeam, worp: `${worp}*`, rest: huidig });
        this.invoer = '';
        this.huidigTeam = this.huidigTeam === 0 ? 1 : 0;
        return;
      }

      // Normale beurt
      this.scores[this.huidigTeam] = nieuw;
      this.beurten.push({ team: this.huidigTeam, worp, rest: nieuw });
      this.invoer = '';

      // Check leg gewonnen
      if (nieuw === 0) {
        this.verwerkLegGewonnen();
        return;
      }

      this.huidigTeam = this.huidigTeam === 0 ? 1 : 0;
    },
    verwerkLegGewonnen() {
      const winnaarTeam = this.huidigTeam;
      if (!this.legWinsten[this.huidigGame - 1]) {
        this.legWinsten[this.huidigGame - 1] = [0, 0];
      }
      this.legWinsten[this.huidigGame - 1][winnaarTeam]++;

      const legsNodig = Math.ceil(this.bestOfLegs / 2);
      if (this.legWinsten[this.huidigGame - 1][winnaarTeam] >= legsNodig) {
        // Game gewonnen
        this.verwerkGameGewonnen(winnaarTeam);
      } else {
        // Volgende leg
        this.huidigLeg++;
        this.resetLeg();
        // Wissel beginteam per leg
        this.huidigTeam = this.huidigTeam === 0 ? 1 : 0;
      }
    },
    verwerkGameGewonnen(winnaarTeam) {
      this.gameWinsten[winnaarTeam]++;
      const gamesNodig = Math.ceil(this.bestOfGames / 2);
      if (this.gameWinsten[winnaarTeam] >= gamesNodig) {
        // Match gewonnen
        this.winnaarNaam = this.teamNamen[winnaarTeam];
        this.fase = 'klaar';
      } else {
        // Volgende game
        this.huidigGame++;
        this.huidigLeg = 1;
        this.resetLeg();
        this.huidigTeam = this.huidigTeam === 0 ? 1 : 0;
      }
    },
  },
}
</script>

<style scoped>
.cijfer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 8px;
}
.cijfer-btn {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  font-size: 1.3rem;
  font-family: 'Poetsen One', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}
.cijfer-btn:hover { border-color: #667eea; background: #ebf4ff; color: #667eea; }
.delete-btn { color: #e53e3e; }
.delete-btn:hover { border-color: #e53e3e; background: #fff5f5; color: #e53e3e; }

.dart-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.dart-table th, .dart-table td {
  padding: 4px 6px;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}
.dart-score-col {
  width: 25%;
  font-weight: 700;
  color: #667eea;
}
.dart-rest-col {
  width: 25%;
  color: #2d3748;
}
.start-score {
  font-weight: 800;
  color: #2d3748;
  font-size: 1rem;
}
.actieve-rij td {
  color: #a0aec0;
  font-style: italic;
}
.pit-optie {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.pit-optie:hover { border-color: #667eea; background: #ebf4ff; }
</style>